import { Action } from '@ngrx/store';

export class MediaAction implements Action {

    public static getVideosByGroupId = '[Media] get_videos_by_group_id';
    public static getVideosByGroupIdSuccess = '[Media] get_videos_by_group_id_success';
    public static getVideosByGroupIdError = '[Media] get_videos_by_group_id_error';

    public static markVideoAsSeen = '[Media] mark_video_as_seen';
    public static markVideoAsSeenError = '[Media] mark_video_as_seen_error';
    public static markVideoAsSeenSuccess = '[Media] mark_video_as_seen_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
